export default __webpack_public_path__ + "static/image-32-70b1d23b6ebb5c43afbe4ceb6c3e7295.jpg";